import { Skeleton, Stack } from "@chakra-ui/react";
import React from "react";

export const TagsLoading: React.FC = () => (
  <Stack aria-label="loading tags" role="alert">
    <Skeleton height="1rem" />
    <Skeleton height="1rem" />
  </Stack>
);
